module.exports = __webpack_public_path__ + "img/fb-icon.efc9ff20.svg";